module.exports = __webpack_public_path__ + "static/media/rad.df30cfad.png";